import { render, staticRenderFns } from "./AdminAllowedIPs.vue?vue&type=template&id=431b8ff3&scoped=true"
import script from "./AdminAllowedIPs.vue?vue&type=script&lang=js"
export * from "./AdminAllowedIPs.vue?vue&type=script&lang=js"
import style0 from "./AdminAllowedIPs.vue?vue&type=style&index=0&id=431b8ff3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431b8ff3",
  null
  
)

export default component.exports